module.exports = __webpack_public_path__ + "static/robotomono-regular-webfont-b4a0c54fcec2dcbe32fca4e6cbb8259c.woff2";